import React, { useState, useEffect } from "react";

const ColorInfo = (/* { props.selectedColor, titleSelectedValue } */ props) => {
    const { titleCopy, titleCopied, titleCurrentValue, titleSelectedValue } =
        props.attributes;

    const [copiedType, setCopiedType] = useState(null);

    const handleCopyClick = async (textToCopy, type) => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopiedType(type);
            setTimeout(() => setCopiedType(null), 5000); // Reset after 5 seconds
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const isMobile = windowWidth <= 768;
    const rowStyle = isMobile
        ? { flexDirection: "column", alignItems: "flex-start" }
        : {};
    const buttonStyle = isMobile ? { marginTop: "10px" } : {};

    return (
        <div
            style={{
                /* width: "100%", */ padding: "20px",
                border: "1px solid #333",
            }}
        >
            <div
                style={{
                    width: "20px",
                    height: "20px",
                    background: props.selectedColor.rgba,
                    border: "1px solid #333",
                }}
            ></div>
            <h3>{titleSelectedValue}:</h3>
            {props.selectedColor.rgba && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        RGBA: {props.selectedColor.rgba}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.rgba, "rgba")
                        }
                    >
                        {copiedType === "rgba" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.hex && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        HEX: {props.selectedColor.hex}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.hex, "hex")
                        }
                    >
                        {copiedType === "hex" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.hsl && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        HSL: {props.selectedColor.hsl}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.hsl, "hsl")
                        }
                    >
                        {copiedType === "hsl" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.cmyk && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        CMYK: {props.selectedColor.cmyk}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.cmyk, "cmyk")
                        }
                    >
                        {copiedType === "cmyk" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.hsv && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        HSV: {props.selectedColor.hsv}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.hsv, "hsv")
                        }
                    >
                        {copiedType === "hsv" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.lab && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        LAB: {props.selectedColor.lab}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.lab, "lab")
                        }
                    >
                        {copiedType === "lab" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.name && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        Name: {props.selectedColor.name}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.name, "name")
                        }
                    >
                        {copiedType === "name" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.rgbaA && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        RGBA (Alpha): {props.selectedColor.rgbaA}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.rgbaA, "rgbaA")
                        }
                    >
                        {copiedType === "rgbaA" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.hsla && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        HSLA: {props.selectedColor.hsla}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.hsla, "hsla")
                        }
                    >
                        {copiedType === "hsla" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.xyz && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        XYZ: {props.selectedColor.xyz}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.xyz, "xyz")
                        }
                    >
                        {copiedType === "xyz" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
            {props.selectedColor.lch && (
                <div
                    className="flex justify-between items-center mb-2"
                    style={rowStyle}
                >
                    <p className="px-4" style={{ wordBreak: "break-word" }}>
                        LCH: {props.selectedColor.lch}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded"
                        style={buttonStyle}
                        onClick={() =>
                            handleCopyClick(props.selectedColor.lch, "lch")
                        }
                    >
                        {copiedType === "lch" ? titleCopied : titleCopy}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ColorInfo;
